import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions, ModalWrapperComponent } from '../../../widgets';
import { SearchService } from '../../services/search.service';



@Component({
  selector: 'app-search-save-popup',
  standalone: true,
  imports: [ModalWrapperComponent, FormsModule],
  templateUrl: './search-save-popup.component.html',
  styleUrls: ['./search-save-popup.component.scss']
})
export class SearchSavePopupComponent implements OnInit {
  @Input() options: ModalOptions = new ModalOptions();

  saveName: string = "";

  isValid: boolean = false;

  constructor(private srchSvc: SearchService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onKeyUp(event: any) {
    if (event.currentTarget.value.length > 0) {
      this.isValid = true;
    }
    else {
      this.isValid = false;
    }
  }

  onSave(event: any) {
    this.activeModal.close(this.saveName);
  }

  onCancel(event: any) {
    this.activeModal.dismiss(event);
  }

}
